import React from 'react';
import SudokuBoard from './sudokoBoard/SudokuBoard.jsx';

function App() {
  return (
    <SudokuBoard></SudokuBoard>
  );
}

export default App;
